import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

/* ======================================================
   MAIN CARD
====================================================== */
export const PageRoot = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  height: "100vh",
}));

export const MainCard = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  padding: "10",
  justifyContent: "space-around",
};

export const cardSearch = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "center",
  "& > *:not(:first-child):not(:last-child)": {
    marginRight: "20px",
  },
  mb: 3,
};

export const MainCard__body = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  display: "flex",
  flexDirection: "column",
  padding: "30px",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  borderRadius: "12px",
  backgroundColor: "transparent",
};

export const MainCard__title = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  borderRadius: "20px",
  background: "#ffffff",
};

export const MainCard__table = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  height: "100%",
  width: "100%",
  marginTop: "10px",
};

export const TitleWrap = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.5),
}));

/* ======================================================
   TITLES
====================================================== */
export const Title = {
  fontWeight: "600",
  fontFamily: "Plus Jakarta Sans",
  fontSize: "17px",
};

export const Description = {
  fontWeight: "400",
  fontFamily: "Plus Jakarta Sans",
  fontSize: "14px",
};

export const TitleG = {
  fontFamily: "Plus Jakarta Sans",
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "140%",
  color: "#15202A",
};

export const Subtitle = {
  fontSize: "16px",
  color: "#5F6C7B",
  marginTop: 0,
};

export const TitleWrapper = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  width: "100%",
  mb: 4,
  mt: 0,
  padding: "10px",
};

/* ======================================================
   BUTTONS
====================================================== */
export const DownloadBottom = {
  border: "none",
  background: "none",
  padding: 0,
  minWidth: 0,
  width: "auto",
  height: "auto",
};

export const ExportButton = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  fontSize: "12px",
  fontWeight: "700",
  color: "#15202A",
  border: "1px solid #15202A",
  borderRadius: "8px",
  textTransform: "none",
};

export const ExportButtonRed = {
  backgroundColor: "#EB0000",
  border: "none",
  color: "white",
  "&:hover": {
    backgroundColor: "#D50000",
    border: "none",
  },
};

export const ApplyButton = {
  height: 33,
  width: 59,
  margin: "25px 0 0 0",
  backgroundColor: "#EB0000",
  border: "none",
  fontWeight: "700",
  fontFamily: "Plus Jakarta Sans",
  fontSize: "12px",
  color: "white",
  textTransform: "none",
  borderRadius: "8px",
  padding: "12px",
  "&:hover": {
    backgroundColor: "#EB0000",
    border: "none",
  },
};

/* ======================================================
   INPUTS
====================================================== */
export const InputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
  },
  "& .MuiInputBase-root, & .MuiInputLabel-root, & .MuiFormLabel-root, & .MuiMenuItem-root, & .MuiSelect-select": {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
  },
  "& .MuiInputBase-input": {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    paddingTop: "8px",
    paddingBottom: "8px",
    display: "flex",
    alignItems: "center",
  },
};

/* ======================================================
   CHECKBOX – GLOBAL (contorno NEGRO / checked VERDE)
====================================================== */
export const GreenCheckbox = {
  color: "#111827",

  "&.Mui-checked": {
    color: "#15803D",
  },

  "&.MuiCheckbox-indeterminate": {
    color: "#15803D",
  },

  "&:hover": {
    backgroundColor: "rgba(21, 128, 61, 0.08)",
  },

  "&.Mui-focusVisible": {
    outline: "none",
  },
};

/* ======================================================
   DATAGRID
====================================================== */
export const DataGridStyles = {
  fontFamily: '"Plus Jakarta Sans", sans-serif',
  display: "flex",
  flexDirection: "column",
  height: "400px",
  border: "none",
  mb: 3,
  borderRadius: "12px",
  overflow: "hidden",

  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#F9F9F9",
    color: "#374151",
    borderBottom: "1px solid #E5E7EB",
    zIndex: 2,
  },

  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#F9F9F9",
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    fontWeight: 700,
    fontSize: "0.9rem",
  },

  "& .MuiDataGrid-filler, & .MuiDataGrid-scrollbarFiller": {
    backgroundColor: "#F9F9F9",
  },

  "& .MuiDataGrid-cell, & .MuiDataGrid-columnHeaderTitle, & .MuiDataGrid-footerContainer, & .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
    {
      fontFamily: '"Plus Jakarta Sans", sans-serif',
    },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "#ECF1F7",
  },

  "& .MuiDataGrid-virtualScroller": {
    overflowY: "auto",
    backgroundColor: "white",
    maxHeight: "400px",
  },

  "& .MuiDataGrid-virtualScrollerRenderZone": {
    backgroundColor: "white",
  },

  ".MuiDataGrid-cell": {
    borderBottom: "1px solid #E5E7EB",
    fontSize: "13px",
    color: "#374151",
  },

  ".MuiDataGrid-columnSeparator": {
    display: "none",
  },

  "& .MuiDataGrid-footerContainer": {
    backgroundColor: "white",
    borderBottomLeftRadius: "12px",
    borderBottomRightRadius: "12px",
  },

  "& .MuiCheckbox-root": {
    color: "#111827",
  },

  "& .MuiCheckbox-root.Mui-checked": {
    color: "#15803D",
  },

  "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
    color: "#15803D",
  },

  "& .MuiCheckbox-root:hover": {
    backgroundColor: "rgba(21, 128, 61, 0.08)",
  },

  "& .MuiCheckbox-root.Mui-focusVisible": {
    outline: "none",
  },

  "& .MuiDataGrid-cell:focus": {
    outline: "none",
  },

  "& .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },

  "& .MuiDataGrid-columnHeader:focus": {
    outline: "none",
  },

  "& .MuiDataGrid-columnHeader:focus-within": {
    outline: "none",
  },
};

/* ======================================================
   BADGES / CHIPS
====================================================== */
export const BadgeStyle = {
  display: "inline-block",
  padding: "6px 14px",
  background: "#f1f6fc",
  color: "#2c3e50",
  fontSize: "16px",
  fontWeight: 600,
  borderRadius: "20px",
  border: "1px solid #e2e8f0",
};

export const ChipBuyStyle = {
  fontFamily: "Plus Jakarta Sans",
  fontSize: "12px",
  fontWeight: "400",
  color: "#075C24",
  borderRadius: "8px",
  background: "#E6F5EA",
  height: "20px",
};

export const ChipSellStyle = {
  fontFamily: "Plus Jakarta Sans",
  fontSize: "12px",
  fontWeight: "400",
  color: "#EB0000",
  borderRadius: "8px",
  background: "#FFE5E5",
  height: "20px",
};

export const ProfitStyles = {
  fontFamily: "Plus Jakarta Sans",
  fontSize: "12px",
  fontWeight: "400",
  color: "#1C7B3E",
};

export const LossStyles = {
  fontFamily: "Plus Jakarta Sans",
  fontSize: "12px",
  fontWeight: "400",
  color: "#EB0000",
};

/* ======================================================
   ACTION CELL
====================================================== */
export const ActionCellWrapper = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const ActionCircle = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "background-color 0.1s ease-in-out",

  "&:hover": {
    backgroundColor: "#eceff1",
  },
};
